export class Funding {
  constructor(
    public projectId: string,
    public fundingCategory: string,
    public totalFunds: number,
    public totalFundingBudget: number,
  ) {}
}
